import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './pages/home/Home';
import PrivacyPolicy from './pages/privacyPolicy/PrivacyPolicy';
import App from './pages/app/App';
import AboutUs from './pages/aboutUs/AboutUs';
import NotFound from './pages/notFound/NotFound';
import ServerError from './pages/serverError/ServerError';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { Auth0Provider } from '@auth0/auth0-react';
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from './utils/errorHandler';

Sentry.init({
  dsn: 'https://7bea201c373e0a17952b5226f296ff2d@o192097.ingest.us.sentry.io/4509295238119424',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const client = new ApolloClient({
  uri: import.meta.env.VITE_API_URL_PROD,
  cache: new InMemoryCache(),
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: 'politica-de-privacidade',
    element: <PrivacyPolicy />,
  },
  {
    path: 'como-funciona',
    element: <Home />,
  },
  {
    path: 'app',
    element: <App />,
  },
  {
    path: 'ofertas',
    element: <App />,
  },
  {
    path: 'sobre-nos',
    element: <AboutUs />,
  },
  {
    path: '500',
    element: <ServerError />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Auth0Provider
    domain={import.meta.env.VITE_PUBLIC_AUTH0_DOMAIN}
    clientId={import.meta.env.VITE_PUBLIC_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    <React.StrictMode>
      <ErrorBoundary>
        <ApolloProvider client={client}>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </ApolloProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  </Auth0Provider>
);
